import styled from "styled-components"
import {Grid as GridBS} from "react-bootstrap"

const Grid = styled(GridBS)`
  padding-top: 30px;
`
export default Grid
